/* eslint-disable @typescript-eslint/no-explicit-any */
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import {LegalEntity} from '@primatoo-ms-organization';
import {DownloadFormat, DownloadResponse} from "@pt/pt-models";
import {DownloadRequest} from "it/primatoo/openapi/api/org/schemas/common/docs/DownloadRequest";

export class ApiClientUtils {

  static defaultFileName = 'download';

  static downloadChapter(httpClient: HttpClient, url: string, request: DownloadRequest, format: DownloadFormat,fileName?: string): Observable<DownloadResponse> {
    const responseType = 'arraybuffer' as any;
    return httpClient.post<any>(url, request, {
      responseType,
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      observe: 'response'
    }).pipe(
      map(resp => {
        if (resp.type === 4) {
          const array = new Uint8Array(resp.body);
          const fName = this.getFileNameFromContentDisposition(resp.headers.get('content-disposition'), format);
          const name = fName ? fName : fileName;// ? fileName : this.getFileNameFromContentDisposition(resp.headers.get('content-disposition'), format);
          return {fileName: name, blob: new Blob([array])} as DownloadResponse;
        }
      })
    );
  }


  static download(httpClient: HttpClient, url: string, format: DownloadFormat,fileName?: string): Observable<DownloadResponse> {
    const responseType = 'arraybuffer' as any;
    return httpClient.get<any>(url, {
      responseType,
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      observe: 'response'
    }).pipe(
      map(resp => {
        if (resp.type === 4) {
          const array = new Uint8Array(resp.body);
          const name = fileName ? fileName : this.getFileNameFromContentDisposition(resp.headers.get('content-disposition'), format);
          return {fileName: name, blob: new Blob([array])} as DownloadResponse;
        }
      })
    );
  }

  static downloadComplete(httpClient: HttpClient, url: string,  format: DownloadFormat, fileName?: string) {
    ApiClientUtils.download(httpClient, url, format, fileName).subscribe((response: DownloadResponse) => {
      if (response) {
        if (response.fileName) {
          FileSaver.saveAs(response.blob, `${response.fileName}`);
        } else {
          FileSaver.saveAs(response.blob, `${fileName}${format}`);
        }
      }
    });
  }

  private static getFileNameFromContentDisposition(contentDisposition: string, format: DownloadFormat) {
    if (contentDisposition) {
      try {
          const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
          if (match && match[1]) {
            return decodeURIComponent(match[1]);
          }
      } catch (e) {
        return ApiClientUtils.defaultFileName + format;
      }
    }
    return ApiClientUtils.defaultFileName + format;
  }


  static buildLegalEntitiesFilter(selectedLegalEntities: LegalEntity[] = [], fieldName: 'legalEntityId' | 'legalEntitiesIds' = 'legalEntityId'): string {
    let formattedFilter = fieldName + '_in_';
    if (selectedLegalEntities?.length > 0) {
      selectedLegalEntities.forEach((legalEntity, idx) => {
        if (idx > 0) {
          formattedFilter = formattedFilter + '|' + legalEntity.id;
        } else {
          formattedFilter = formattedFilter + legalEntity.id;
        }
      });
    }
    return encodeURI(formattedFilter);
  }

  static buildAttachmentsUuidFilter(uuids?: number[]): string {
    let formattedFilter = 'uuids=';
    if (uuids?.length > 0) {
      uuids.forEach((uuid, idx) => {
        if (idx > 0) {
          formattedFilter = formattedFilter + ',' + uuid;
        } else {
          formattedFilter = formattedFilter + uuid;
        }
      });
    }
    return encodeURI(formattedFilter);
  }

  static buildArrayFilter(items: any[]): string {
    let formattedFilter = '';
    if (items?.length > 0) {
      items.forEach((item, idx) => {
        if (idx > 0) {
          formattedFilter = formattedFilter + ',' + item?.toString();
        } else {
          formattedFilter = formattedFilter + item?.toString();
        }
      });
    }
    return encodeURI(formattedFilter);
  }

  public static buildAndAppendHttpParams(args: { [key: string]: any }): HttpParams {
    let params = new HttpParams();
    Object.keys(args).forEach((key) => {
      if (key && args[key]) {
        params = params.append(key, args[key])
      }
    })
    return params;
  }

  public static buildAndAppendHttpHeaders(args: { [key: string]: any }): HttpHeaders {
    let header = new HttpHeaders();
    Object.keys(args).forEach((key) => {
      if (key && args[key]) {
        header = header.append(key, args[key])
      }
    })
    return header;
  }
}



